<template>
  <div class="syllablestable table-container">
    <table class="syllablestablebody table">
      <template v-for="number in Numbers">
        <tr :key="number">
          <td>{{ number }}</td>
          <td
            class="syllables__td is-size-7-mobile  is-size-4"
            @click="selectSign(sign)"
            v-for="sign in Syllables[number]"
            :key="sign"
          >
            <span :class="cuneiformClass">
              {{ sign }}
            </span>
          </td>
        </tr>

        <tr :key="number + '_'" class="syllables_divider"></tr>
      </template>
    </table>
  </div>
</template>

<script>
const table = require("@/data/syllables_table.json");

export default {
  props: {
    cuneiformClass: {
      type: String,
      default: "akkadian"
    }
  },
  computed: {
    Numbers: function() {
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
    },
    Syllables() {
      return table["syllables"];
    }
  },
  methods: {
    selectSign(sign) {
      this.$emit("select", { sign: sign });
    }
  }
};
</script>

<style lang="sass">
.syllablestable
    margin: 0 auto
.syllablestablebody
  margin: 0 auto

.syllables_divider
  height:15px

.syllables__td
  padding:2px

table.table td:hover
  background-color: #CCFFFF

span.sylllables__cuneiform
  margin:0px 5px
</style>
